import React, { ReactFragment } from 'react';

interface Props {
  title: string
  type?: 'titolo' | 'sottotitolo' | 'testo'
  className?: string
  children?: ReactFragment
}

const Text: React.VFC<Props> = (props: Props) => {

  const {
    title,
    type = 'testo',
    className = '',
    children
  } = props;


  return (

    <div className={`text-${type} ${className}`}>
      {title} {children || ""}
    </div>

  );

}


export default Text;
